<p-toast></p-toast>

<p-card>

    <div class="card">
        <p-toolbar [style]="{'background-color':'#2196f3'}">
            <ng-template pTemplate="left">
                <button pButton pRipple label="NOVO" icon="pi pi-plus" class="p-button-success p-mr-2"
                    (click)="abrirNovo()"></button>
                <!-- <button pButton pRipple [label]="Delete" icon="pi pi-trash" class="p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedCliente || !selectedCliente.length"></button> -->
            </ng-template>

            <ng-template pTemplate="right">
                <!-- <button type="button" pButton pRipple icon="pi pi-filter" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button>     -->
            </ng-template>
        </p-toolbar>
        <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" *ngIf="loading"></p-progressBar>

        <p-table #dt [value]="clientes" selectionMode="single" [(selection)]="selectedCliente"
            styleClass="p-datatable-sm p-datatable-striped" dataKey="cod_cliente" [globalFilterFields]="['nome']"
            [scrollable]="true" scrollHeight="300px">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h2 class="p-m-0">CLIENTES</h2>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="Buscar..." />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Código</th>
                    <th>Nome</th>
                    <th>Endereco</th>
                    <th style="text-align: right;">Ações</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-cliente>
                <tr [pSelectableRow]="cliente">
                    <td>{{cliente.cod_cliente}}</td>
                    <td>{{cliente.nome}}</td>
                    <td>{{cliente.endereco}}, {{cliente.numero}}</td>
                    <td style="text-align: right;">
                        <button style="background-color: #3F51B5;" pButton pRipple icon="pi pi-pencil"
                            class="p-button-rounded p-button-success p-mr-2" (click)="Editar(cliente)" pTooltip="Editar"
                            tooltipPosition="bottom"></button>
                        <button style="background-color: red; color: white;" pButton pRipple icon="pi pi-trash"
                            class="p-button-rounded p-button-warning" (click)="Deletar(cliente)" pTooltip="Deletar"
                            tooltipPosition="bottom"></button>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <hr />
    <span style="
      background-color: #3F51B5;
      color: white;
      border-radius: 20px;
      padding: 5px;">Registros: {{total}}</span>
</p-card>

<!----=============================================================EDITAR============================================------>
<p-dialog [(visible)]="clienteDialog" [style]="{'height': '100%', 'width':'90%'}" [modal]="true" [baseZIndex]="10000" #dialogCliente
    styleClass="p-fluid">
    <p-header>
        Dados do Cliente
    </p-header>
    <hr />
    <ng-template pTemplate="content">    
        <p-tabView>
            <p-tabPanel header="DADOS">

                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-6 p-lg-7">
                        <label for="nome"><b>Nome</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText [(ngModel)]="cliente.nome" required
                            autofocus />
                        <small class="p-invalid" *ngIf="submitted && !cliente.nome">Nome é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-5">
                        <label for="nome_fantasia"><b>Nome Fantasia</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText [(ngModel)]="cliente.nome_fantasia"
                            required />
                        <small class="p-invalid" *ngIf="submitted && !cliente.nome_fantasia">Nome Fantasia é
                            obrigatório.</small>
                    </div>
                </div>

                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <label for="cpf_cnpj"><b>CPF/CNPJ</b></label>
                        <p-inputMask class="p-inputtext-sm" mask="99999999999?999" [(ngModel)]="cliente.cpf_cnpj"
                            placeholder="Apenas Dígitos"></p-inputMask>
                            <small class="p-invalid" *ngIf="submitted && !cliente.cpf_cnpj">CPF/CNPJ é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <label for="numero"><b>Telefone</b></label>
                        <p-inputMask class="p-inputtext-sm" mask="(99)99999-9999" [(ngModel)]="cliente.telefone"
                            placeholder="(99)99999-9999"></p-inputMask>
                            <small class="p-invalid" *ngIf="submitted && !cliente.telefone">Telefone é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <label for="email"><b>Email</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText [(ngModel)]="cliente.email"
                            placeholder="email@exemplo.com.br"/>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="ENDEREÇO">
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <label for="cep"><b>CEP</b></label>

                        <span class="p-input-icon-right">
                            <i *ngIf="buscandoCep" class="pi pi-spin pi-spinner"></i>
                            <p-inputMask #txtCEP class="p-inputtext-sm" mask="99999-999" 
                            [(ngModel)]="cliente.cep" (keyup.enter)="buscaCep($event)"
                            placeholder="99999-999"></p-inputMask>
                        </span>
                        <small class="p-invalid" *ngIf="submitted && !cliente.cep">CEP é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <label for="estado"><b>Estado</b></label>
                        <p-dropdown class="p-inputtext-sm" [options]="estados" [(ngModel)]="selecionarEstado"
                         optionLabel="nome" optionValue="codigo"></p-dropdown>
                         <small class="p-invalid" *ngIf="submitted && !selecionarEstado">Estado é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <label for="cidade"><b>Cidade</b></label>
                        <input class="p-inputtext-sm" pInputText [(ngModel)]="cliente.cidade"/>
                        <small class="p-invalid" *ngIf="submitted && !cliente.cidade">Cidade é obrigatório.</small>
                    </div>
                </div>
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <label for="endereco"><b>Endereço</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText
                            [(ngModel)]="cliente.endereco" required />
                            <small class="p-invalid" *ngIf="submitted && !cliente.endereco">Endereço é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-2">
                        <label for="numero"><b>Número</b></label>
                        <input type="text" #txtNumero class="p-inputtext-sm" pInputText  [(ngModel)]="cliente.numero"
                            required autofocus />
                            <small class="p-invalid" *ngIf="submitted && !cliente.numero">Número é obrigatório.</small>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-4">
                        <label for="complemento"><b>Complemento</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText  [(ngModel)]="cliente.complemento"/>
                    </div>
                </div>
                <div class="p-grid p-fluid">
                    <div class="p-col-12 p-md-6 p-lg-12">
                        <label for="bairro"><b>Bairro</b></label>
                        <input type="text" class="p-inputtext-sm" pInputText  [(ngModel)]="cliente.bairro"/>
                        <small class="p-invalid" *ngIf="submitted && !cliente.bairro">Bairro é obrigatório.</small>
                    </div>
                </div>
                <div class="p-grid p-fluid">
                <div class="p-col-12 p-md-6 p-lg-12">
                    <label for="observacao"><b>Observação</b></label>
                    <textarea class="p-inputtext-sm" pInputTextarea [(ngModel)]="cliente.observacao"></textarea>
                </div>
            </div>
            </p-tabPanel>
        </p-tabView>
    </ng-template>

    <ng-template pTemplate="footer">
        <hr />

        <button pButton pRipple label="Limpar" icon="pi pi-times-circle" class="p-button-raised p-button-danger"
            (click)="limparCampos()" style="float: left;"></button>
        <!-- <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-raised p-button-danger" (click)="fecharDialogo()"></button> -->
        <button pButton pRipple label="Incluir" icon="pi pi-check" [disabled]="cliente.cod_cliente > 0"
            class="p-button-raised" (click)="Salvar()"></button>
        <button pButton pRipple label="Alterar" icon="pi pi-check" [disabled]="cliente.cod_cliente == ''"
            class="p-button-raised p-button-warning" (click)="Salvar()" style="margin-right: 0px;"></button>
    </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '500px'}"></p-confirmDialog>